import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Third-party Modules
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { MarkdownModule } from 'ngx-markdown';

// App Modules
import { AppRoutingModule } from './app.routes';
import { AppCommonModule } from './components/common/app-common.module';
import { SharedServicesModule } from './services/shared-services.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

// Components
import { AppComponent } from './app.component';

// Services
import { RoutePartsService } from './services/route-parts/route-parts.service';
import { NavigationService } from './services/navigation/navigation.service';
import { ChatterService } from './chat/shared/services/chatter.service';
import { AuthService } from './services/auth/auth.service';
import { SiteReviewService } from './services/site-review.service';
import { featureFlagInitializer } from './core/feature-flags/feature-flags.initializer';
import { FeatureFlagService } from './core/feature-flags/feature-flags.service';
import { RouteReuseStrategy } from '@angular/router';
import { KeepAliveRouteReuseStrategy } from './core/routing/keep-alive-route-reuse.strategy';
import { WbExpandedSearch } from './components/grid-toolbar/wb-expanded-search/wb-expanded-search';

@NgModule({
  declarations: [
    AppComponent,
    WbExpandedSearch,
  ],
  imports: [ 
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,  
    // RouterModule.forRoot(rootRouterConfig, { useHash: false }), 
    AppCommonModule,
    SharedServicesModule,
    QuillModule.forRoot(),
    ToastrModule.forRoot(),
    MarkdownModule.forRoot(),
  ],
  exports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppCommonModule
  ],
  providers: [
    RoutePartsService,
    NavigationService,
    ChatterService,
    AuthService,
    SiteReviewService,
    {
      provide:    APP_INITIALIZER,
      useFactory: featureFlagInitializer,
      deps:       [FeatureFlagService],
      multi:      true, 
    },
    // Only affects routes flagged `data: { keepAlive: true }`; all others keep
    // Angular's default reuse behavior.
    KeepAliveRouteReuseStrategy,
    { provide: RouteReuseStrategy, useExisting: KeepAliveRouteReuseStrategy },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' } 
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}